import React from 'react'
import './LRTableRow.css'

const LRTableRowUI = ({context, object, className, left, right, onClick, rowId}) =>
  <div
    className={`w_lr_tbl_r g_flex_h ${onClick ? 'active' : ''} ${className ? className : ''}`}
    onClick={onClick}
    data-row-id={rowId}
    ref={(element) => {
      // this ref is used for scrolling into view in task list arrow navigation
      if (object) {
        object._element = element
      }
    }}
  >
    <div className='left'>
      {left}
    </div>
    <div className='right'>
      {right}
    </div>
  </div>

export default LRTableRowUI
